import {getPrivateAxios} from '../../libs';

interface GuideFavorite {
  isFavorite: boolean;
}

export const fetchGuideFavorite = async (guideId: string) => {
  const {data} = await getPrivateAxios().post<GuideFavorite>(`/guides/${guideId}/favorite`);
  return data;
};
